import { render, staticRenderFns } from "./_btg.vue?vue&type=template&id=c4021298&lang=pug&"
import script from "./_btg.vue?vue&type=script&lang=js&"
export * from "./_btg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports